import {ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import type {ListExtensions} from '../__generated/ListExtensions';

export type Extension = ListExtensions['extensionRegistryListing']['items'][number];

export const EXTENSION_TYPE_LABELS: Record<ExtensionType, string> = {
  [ExtensionType.AGENT_SKILL]: 'Agent Skill',
  [ExtensionType.MCP_SERVER]: 'MCP',
  [ExtensionType.MODEL]: 'Scientific Model',
};

/**
 * Version tags that can be assigned to an extension version.
 * Must match the backend enum (AIModelVersionTag in ai_model_version_tags.py).
 */
export enum ModelVersionTag {
  DEFAULT = 'DEFAULT',
}

export const VERSION_TAGS_BY_EXTENSION_TYPE: Partial<Record<ExtensionType, Array<string>>> = {
  [ExtensionType.MODEL]: Object.values(ModelVersionTag),
};
